import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'empathy-randomized-options-setting',
  templateUrl: 'randomized-options-setting.component.html',
  styleUrls: ['./randomized-options-setting.component.scss', './_randomized-options-settings-theme.component.scss']
})
export class RandomizedOptionsSettingComponent {
  @Input() activeQuestion: FormGroup;
  @Input() showBorder = true;
}
